<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <div class="pagination-container">
          <el-pagination
            :disabled="$data.$_useElementUIPaginationMixin_isLoading"
            :current-page="$data.$_useElementUIPaginationMixin_listQuery.page"
            :page-sizes="$data.$_useElementUIPaginationMixin_listQuery.sizes"
            :page-size="$data.$_useElementUIPaginationMixin_listQuery.size"
            :total="$data.$_useElementUIPaginationMixin_listQuery.total"
            background
            layout="total, sizes, pager, jumper"
            @size-change="$_useElementUIPaginationMixin_handleSizeChange"
            @current-change="$_useElementUIPaginationMixin_handlePageChange"
          />
        </div>
      </div>
    </template>
    <el-table
      v-loading="$data.$_useElementUIPaginationMixin_isLoading"
      :data="$data.$_useElementUIPaginationMixin_list"
      border
      stripe
      style="width: 100%">
      <el-table-column
        prop="id"
        label="ID"
        width="50"
      />
      <el-table-column
        prop="member.email"
        label="Member Email"
        min-width="200"
      />
      <el-table-column
        prop="reward.name"
        label="Requested Gift Card Name"
        min-width="200"
      />
      <el-table-column
        label="Status"
        align="center"
        width="90">
        <template slot-scope="scope">
          <div class="status-row">
            <el-tag :type="scope.row.isSent ? 'success' : 'warning'">{{ scope.row.status }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Created At"
        width="150">
        <template slot-scope="scope">
          <i class="el-icon-time"/>
          <span style="margin-left:5px;">{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="Action"
        align="center"
        width="200">
        <template slot-scope="scope">
          <div
            v-if="!scope.row.isSent"
            class="coupon-code-input"
          >
            <el-input
              :disabled="scope.row.isSent || scope.row.isLoading"
              v-model.trim="scope.row.couponText"
              placeholder="Coupon Code"
              size="mini"
              clearable
            />
            <el-button
              :disabled="scope.row.isSent || !scope.row.couponText"
              :loading="scope.row.isLoading"
              size="mini"
              type="danger"
              icon="el-icon-message"
              circle
              @click="showCouponCodePrompt(scope.row)"
            />
          </div>
          <span v-else>No Action Required</span>
        </template>
      </el-table-column>
    </el-table>
  </sticky-header-layout>
</template>

<script>
import { getRewards, sendCouponCode } from '../../api/memberships'

export default {
  name: 'GoxipCircleRewardList',
  mounted() {
    this.$_useElementUIPaginationMixin_getList()
  },
  methods: {
    async $_useElementUIPaginationMixin_getList() {
      this.$data.$_useElementUIPaginationMixin_isLoading = true
      try {
        const response = await getRewards(this.$data.$_useElementUIPaginationMixin_listQuery.page, this.$data.$_useElementUIPaginationMixin_listQuery.limit)
        const { data: newList, pagination } = response

        this.$data.$_useElementUIPaginationMixin_list = newList.map((item) => {
          item.isLoading = false
          item.couponText = ''
          item.status = item.used_at ? 'Sent' : 'Pending'
          item.isSent = !!item.used_at
          return item
        })

        this.$data.$_useElementUIPaginationMixin_listQuery.total = parseInt(pagination.total_items, 0)
      } catch (error) {
        // Handle later
      } finally {
        this.$data.$_useElementUIPaginationMixin_isLoading = false
      }
    },
    async applyCouponCode(reward) {
      reward.isLoading = true
      const { id, couponText } = reward

      try {
        await sendCouponCode(id, couponText)
        reward.isSent = true
        reward.status = 'Sent'
        reward.couponText = ''
        reward.isLoading = false
      } catch (error) {
        reward.isLoading = false
      }
    },
    async showCouponCodePrompt(reward) {
      const title = `You are about to send coupon code "${reward.couponText}" to a user.` +
      ' This action cannot be undone. Continue?'

      try {
        await this.$confirm(title, 'Warning', {
          confirmButtonText: 'Send',
          cancelButtonText: 'Cancel',
          type: 'warning',
        })
        this.applyCouponCode(reward)
      } catch (error) {
        // Nothing to handle
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

.status-row {
  display: flex;
  justify-content: center;
  align-items: center;
}
.coupon-code-input {
  display: flex;
  justify-content: space-between;
  .el-input {
    width: 140px;
  }
}
</style>

